import PassengerFieldSwitch from './components/Passenger/Field/Switch/Switch.css';
import Input from './components/Input/Input.css';
import OrderBooking from './components/OrderCard/OrderBooking/OrderBooking.css';
import Account from './components/Account/Account.css';
import DeleteAccountDialog from './components/Account/DeleteAccountDialog/DeleteAccountDialog.css';
import AddBooking from './components/AddBooking/AddBooking.css';
const accountTheme = {
    Passenger: {
        Switch: {
            element: PassengerFieldSwitch.element,
            element_active: PassengerFieldSwitch.element_active
        }
    },
    Input: {
        Input: {
            input_filled: Input.input_filled,
            input: Input.input,
            real_input: Input.real_input,
            input_focused: Input.input_focused,
            disabled: Input.disabled
        }
    },
    OrderCard: {
        OrderBooking: {
            icon: OrderBooking.icon,
            type_account: OrderBooking.type_account,
            root: OrderBooking.root
        }
    },
    AccountModule: {
        Account: {
            route__title: Account.route__title,
            active__route: Account.active__route
        }
    },
    ProfileControls: {
        ProfileControls: {
            wrapper: Account.profileControls_wrapper
        }
    },
    AddBooking: {
        AddBooking: {
            button: AddBooking.button,
            buttonContinue: AddBooking.buttonContinue
        }
    },
    Account: {
        Account: {
            account__deleteModal: Account.account__deleteModal
        },
        DeleteAccountDialog: {
            Dialog: DeleteAccountDialog.dialog,
            actions: DeleteAccountDialog.dialog_actions,
            title: DeleteAccountDialog.title,
            text: DeleteAccountDialog.text,
            closeButton: DeleteAccountDialog.closeButton
        }
    }
};
export default accountTheme;
